import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { categories } from '../Api';
import { RootState } from '../Redux/Store/Store';
import { SET_MAIN_CATEGORY_LIST, SET_SELECTED_CATEGORY } from '../Redux/mainCategory';

/**
 * The default main category is the one with the lowest id
 */
export const getDefaultMainCategory = (list: any[]) =>
  [...list].sort((a, b) => (a.id < b.id ? -1 : a.id > b.id ? 1 : 0))[0];

/**
 * Makes sure a main category is selected, for pages that can be opened without
 * passing through Home (e.g. the store page on a seller's custom domain: shop.example.com)
 * @returns the selected main category
 */
export const useEnsureMainCategory = () => {
  const dispatch = useDispatch();
  const selectedMainCategory = useSelector(
    (state: RootState) => state.mainCategory.selectedMainCategory
  );

  useEffect(() => {
    if (selectedMainCategory?.id) return;

    // ignore a late response if the component unmounted in the meantime to prevent any race conditions
    let cancelled = false;
    categories()
      .then((response) => {
        if (cancelled || !response?.data?.length) return;
        dispatch(SET_MAIN_CATEGORY_LIST(response.data));
        dispatch(SET_SELECTED_CATEGORY(getDefaultMainCategory(response.data)));
      })
      .catch((error) => console.log('Error fetching categories', error));

    return () => {
      cancelled = true;
    };
  }, [dispatch, selectedMainCategory?.id]);

  return selectedMainCategory;
};

export default useEnsureMainCategory;
